module.exports = __webpack_public_path__ + "static/media/2-audio.9f67cb0.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-audio.wav
// module id = cFvC
// module chunks = 0